export class InternationalCreditCardNotSupportedError extends Error {
  public constructor(phoneNumber: string) {
    super(
      `To place an order and pay using a credit card issued in a country outside of the United States, Canada, or the United Kingdom, please call our customer service team at ${phoneNumber}. Alternatively, you can place your order online by selecting Apple Pay, Google Pay or PayPal as your payment method.`,
    );
  }
}
